$(function () {
    var $resolution = $('input[name="_resolution"]');
    $resolution.val(window.screen.width + "x" + window.screen.height);
});

$(document).on(
    "ajax:request-error",
    "[data-request-validation]",
    function (ev) {
        const { context, message: statusText, xhr: jqXHR } = ev.detail;
        var $form = $(this),
            fixedMessage =
                $form.attr("data-form-fixed-message") === "false"
                    ? false
                    : true,
            prependMessage =
                $form.attr("data-form-message") === "true" ? true : false,
            appendMessage =
                $form.attr("data-form-message-bottom") === "true"
                    ? true
                    : false,
            addErrorClasses =
                $form.attr("data-field-error-classes") === "false"
                    ? false
                    : true,
            addErrorMessagesToFields =
                $form.attr("data-field-error-messages") === "false"
                    ? false
                    : true;

        // Get error message
        var errorMessage = (statusText.$env && statusText.$env.message)
            ? statusText.$env.message
            : 'There has been a problem submitting the form, please check you have completed it correctly and try again.';

        var message =
            '<div class="form-response form-error-message alert alert-warning">' +
            errorMessage +
            "</div>";

        // Remove old ones
        $(".form-fixed-response").remove();
        $form.find(".form-error-message").remove();

        // Add fixed error message to page
        if (fixedMessage === true) {
            $("body").append(
                '<div class="form-fixed-response"><div class="container">' +
                    message +
                    "</div></div>",
            );
            $(".form-fixed-response").fadeIn(200);
        }

        if (prependMessage === true) {
            // Prepend error message
            $form.prepend(message);
        }

        if (appendMessage === true) {
            // Append error message
            $form.append(message);
        }

        if (addErrorClasses === true || addErrorMessagesToFields === true) {
            var errorFields = (statusText.$env && statusText.$env.invalid);

            // Remove fields with error class
            $form.find(":input.is-erroneous").removeClass("is-erroneous");

            // Remove field error message
            $form.find(".input-error-message").remove();

            if (errorFields) {
                $.each(errorFields, function (field, message) {
                    // fixes names and messages of fields in an array
                    if (field.indexOf(".") !== -1) {
                        field = field.replace(".", "[") + "]";
                        message[0] = message[0].replace(".", " ");
                    }

                    var $field = $form.find(':input[name="' + field + '"]');

                    if (addErrorClasses === true)
                        $field.addClass("is-erroneous");
                    if (addErrorMessagesToFields === true) {
                        if ($field.attr("type") === "checkbox") {
                            $field
                                .parent(".form-check")
                                .append(
                                    '<div class="input-error-message">' +
                                        message[0] +
                                        "</div>",
                                );
                        } else if ($field.attr("type") === "radio") {
                            $field
                                .parents(".form-group")
                                .append(
                                    '<div class="input-error-message">' +
                                        message[0] +
                                        "</div>",
                                );
                        } else if ($field.is("select")) {
                            $field
                                .parents(".form-group")
                                .append(
                                    '<div class="input-error-message">' +
                                        message[0] +
                                        "</div>",
                                );
                        } else {
                            $field.after(
                                '<div class="input-error-message">' +
                                    message[0] +
                                    "</div>",
                            );
                        }
                    }

                    if ($field.length == 0) {
                        var $label = $form
                            .find(':input[name="' + field + '[]"]')
                            .parents(".form-group")
                            .first("label");
                        if (addErrorMessagesToFields === true)
                            $label.after(
                                '<div class="input-error-message">' +
                                    message[0] +
                                    "</div>",
                            );
                    }
                });
            }
        }

        // remove fixed error message after 5 secs
        setTimeout(function () {
            $(".form-fixed-response").fadeOut(300, function () {
                $(this).remove();
            });
        }, 5000);

        // This prevents the alert from showing.
        ev.preventDefault();
    },
);

$(document).on(
    "ajax:request-success",
    "[data-request-validation]",
    function (ev) {
        const { context, data, xhr: jqXHR } = ev.detail;
        var $form = $(this),
            fixedMessage =
                $form.attr("data-form-fixed-message") === "false"
                    ? false
                    : true,
            prependMessage =
                $form.attr("data-form-message") === "true" ? true : false,
            appendMessage =
                $form.attr("data-form-message-bottom") === "true"
                    ? true
                    : false,
            clearForm =
                $form.attr("data-clear-on-success") === "false" ? false : true,
            successMessage =
                $form.attr("data-success-message") ||
                "Thanks, your message has been submitted successfully";

        // Remove fixed form message
        $(".form-fixed-response").fadeOut(300, function () {
            $(this).remove();
        });

        // Remove prepended error message
        $form.find(".form-error-message").remove();

        // Remove fields with error class
        $form.find(":input.is-erroneous").removeClass("is-erroneous");

        // Remove field error message
        $form.find(".input-error-message").remove();

        var message =
            '<div class="form-error-message alert alert-success">' +
            successMessage +
            "</div>";

        // Add fixed success message to page
        if (fixedMessage === true) {
            $("body").append(
                '<div class="form-fixed-response"><div class="container">' +
                    message +
                    "</div></div>",
            );
            $(".form-fixed-response").fadeIn(200);
        }

        // Prepend success message
        if (prependMessage === true) {
            $form.prepend(message);
        }

        // Append success message
        if (appendMessage === true) {
            $form.append(message);
        }

        if (clearForm === true) {
            $form
                .find(":input")
                .removeAttr("checked")
                .removeAttr("selected")
                .not(
                    "[type=checkbox], [type=radio], :button, :submit, :reset, :hidden",
                )
                .val("");
        }

        // remove success labels after 5 secs
        setTimeout(function () {
            $form.find(".form-error-message").slideUp(400, function () {
                $(this).remove();
            });

            $(".form-fixed-response").fadeOut(300, function () {
                $(this).remove();
            });
        }, 5000);
    },
);

$(document).on("ajax:request-success", "[data-ga-event]", function (ev) {
    const { context, data, xhr: jqXHR } = ev.detail;
    var $this = $(this);

    var eventAction = $this.data("ga-action")
        ? $this.data("ga-action")
        : "submit";

    if (typeof gtag === "function") {
        gtag("event", eventAction, {
            event_category: $this.data("ga-category"),
            event_label: $this.data("ga-label"),
        });
    } else if (typeof ga === "function") {
        ga("send", {
            hitType: "event",
            eventCategory: $this.data("ga-category"),
            eventAction: eventAction,
            eventLabel: $this.data("ga-label"),
        });
    }
});

// Custom success script (october one can be tempremental)
$(document).on("ajax:request-success", "[data-success-script]", function (ev) {
    const { context, data, xhr: jqXHR } = ev.detail;
    var $form = $(this);

    eval($form.data("success-script"));
});

// disable submit button when making request
$(document).on("submit", "[data-request]", function () {
    var $form = $(this),
        $submit = $form.find('[type="submit"]');

    $submit.prop("disabled", true);
});

// re-enable submit button after request is done
$(document).on("ajax:request-complete", "[data-request]", function (ev) {
    const { context, data, xhr: jqXHR } = ev.detail;
    var $form = $(this),
        $submit = $form.find('[type="submit"]');

    $submit.prop("disabled", false);
});
